import styled from "styled-components";
import { registrationScrollBodyStyles } from "../RegistrationLayout/registrationScrollBodyStyles";
import { registrationCardHeaderStyles } from "../RegistrationLayout/registrationFlowLayout";
import { registrationFormStyles } from "../RegistrationLayout/registrationFormStyles";
import { REGISTRATION_FONT_BODY } from "../RegistrationLayout/registrationTheme";

const PaymentSetupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  background: transparent;
  font-family: ${REGISTRATION_FONT_BODY};

  .scroll-body {
    ${registrationScrollBodyStyles}
  }

  .registration-card-header {
    ${registrationCardHeaderStyles}
  }

  .content-card-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 32px 20px calc(28px + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    @media (min-width: 600px) {
      padding: 32px 32px calc(36px + env(safe-area-inset-bottom, 0px));
    }
  }

  .pay-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-bottom: 24px;

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  .pay-card {
    border: 2px solid rgba(30, 42, 53, 0.12);
    border-radius: 12px;
    padding: 24px 20px;
    cursor: pointer;
    transition: all 0.2s;
    background: #ffffff;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family: ${REGISTRATION_FONT_BODY};

    &:hover {
      border-color: #aece38;
      box-shadow: 0 4px 16px rgba(175, 209, 53, 0.15);
    }

    &.selected {
      border-color: #aece38;
      background: rgba(174, 206, 56, 0.1);
      box-shadow: 0 4px 16px rgba(175, 209, 53, 0.18);
    }
  }

  .pay-card-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(174, 206, 56, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    flex-shrink: 0;
  }

  .pay-card.selected .pay-card-icon {
    background: rgba(174, 206, 56, 0.2);
  }

  .pay-card-name {
    font-size: 15px;
    font-weight: 700;
    color: #5a6b80;
    margin-bottom: 4px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .pay-card-desc {
    font-size: 12px;
    color: #6e7d8f;
    line-height: 1.5;
    font-family: ${REGISTRATION_FONT_BODY};
    flex: 1;
  }

  .pay-card-check {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid rgba(30, 42, 53, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
    transition: all 0.2s;
    flex-shrink: 0;
  }

  .pay-card.selected .pay-card-check {
    background: #aece38;
    border-color: #aece38;
  }

  .continue-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 14px 28px;
    border-radius: 999px;
    border: none;
    background: #aece38;
    color: #2d3f52;
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
      background: #8aab15;
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(174, 206, 56, 0.35);
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  }

  ${registrationFormStyles}
`;

export default PaymentSetupWrapper;
